<template>
  <section id="footer" class="mainGray">
    <div>
      <p>
        <small>
          Copyright &#169; 2018 FK Skin&Hair. All rights reserved.
          <a href="http://www.beian.miit.gov.cn" target="_blank"
            >京ICP备19037287号</a
          >
        </small>
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      type: String,
    };
  },
  components: {},
  computed: {},
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
#footer {
  padding: 32px;
  width: 100%;
  height: 130px;

  // background: #f5f5f5;
  > div {
    margin: 0 auto;
    max-width: 1200px;
  }
  p {
    // font-size: 24px;
    // line-height: 52px;
    color: #999;
    text-align: center;
    border-bottom: 1px solid #999;
    > small {
      font-size: 24px;
    }
    &:last-child {
      border-bottom: 0;
    }
    @media (min-width: 768px) {
      font-size: 14px;
      line-height: 32px;

      > small {
        font-size: 14px;
      }
    }
  }

  @media (max-width: 750px) {
    padding-top: 48px;
    height: 152px;
    p {
      font-size: 24px;
      line-height: 36px;

      a {
        display: block;
      }
    }
  }
}
</style>
